<div class="enrollment-steps" id="configure-enrollment-offer-step" data-cy="configure-enrollment-offer-step">
  <app-configure-enrollment-offer-form></app-configure-enrollment-offer-form>
</div>
